module.exports = __webpack_public_path__ + "img/Patch19.8a04d156.webp";